export default {
  manufacturers: 'Manufacturers',
    rights: 'Roles',
    coupon: 'Coupons',
    images: 'Customer Images',
    datainit: 'Branch Init Data',
    templatedetails: 'Template Details',
    sharedimgs: 'Shared Patterns',
    orgdetails: 'Branch Details',
    productDetails: 'Pattern Details',
    clothSize: 'Sizes',
    // 2026-08-24: Add report catalog and distinguish homepage banners from messages.
    report: 'Report Design',
    ordersTitle: 'Orders',
    platformTitle: 'Platform',
    platform: {
      // 2026-09-17: Platform-only merchant terminology; branch labels stay unchanged.
      merchants: 'Merchants',
      platforminfo: 'Platform Info',
      accounts: 'Accounts',
      defaultFunctions: 'New Store Defaults',
      // 2026-08-24: Consolidate customer types, VIP roles, prices, and multi-surface functions.
      orgrights: 'VIP Role Control',
      feedback: 'Feedback',
    },
    orders: {
      bokesOrder: 'E-Pattern Orders',
      clothsOrders: 'Ready-Made Orders',
      decorationOders: 'Accessory Orders',
      fabricsOrder: 'Fabric Orders',
      accessoriesOrder: 'Trim Orders',
      physicalBokes: 'Paper Pattern Orders',
      physicalPrinting: 'Paper Print',
      tailoredOrders: 'Measure Orders',
      tailoredBokes: 'Custom Pattern Orders',
      tailoredCloths: 'Custom Garment Orders',
      clothsOrder: 'Ready-Made Orders',
      tailoredMade: 'Tailor Custom Orders',
      tailoredMadeDetail: 'Tailor Custom Detail',
      videoTeching: 'Course Orders',
      takeOrders: 'Garment Orders',
      upgration: 'Membership Upgrade',
      autoscaleOrders: 'Smart Measure Orders'
    },
    customersTitle: 'Customers',
    customers: {
      customers: 'Customers',
      levels: 'Levels',
      notes: 'Coupons',
      extention: 'Renewal Review',
    },
    auditedTitle: 'Review',
    audited: {
      ref: 'Pattern Reference',
      shared: 'Pattern Sharing',
      settings: 'Review Settings',
      fabrics: 'Fabric Review',
      accessories: 'Trim Review',
      decorations: 'Accessory Review',
      // 2026-08-10：Split pattern review from garment and custom garment review.
      bokes: 'Pattern Review',
      cloths: 'Custom Garment Review',
      retailCloths: 'Ready-Made Garment Review',
      upShare: 'Sales Review'
    },
    productsTitle: 'Products',
    products: {
      bokes: 'Patterns',
      branchProducts: 'Patterns',
      cloths: 'Garments',
      clothDetails: 'Garment Details',
      parentSharedprds: 'Platform Products',
      upsharedProducts: 'Branch Sales',
      fabrics: 'Fabrics',
      upshare: 'List on Platform',
      fabricDetails: 'Fabric Details',
      accessories: 'Accessories',
      decorationDetails: 'Accessory Details',
      accessoryDetails: 'Accessory Details',
      decoration: 'Decorations',
      sharingFromOther: 'Branch Products',
      binding: 'Batch Binding',
      accessoriesDetails: 'Accessory Details'
    },
    systemTitle: 'Settings',
    system: {
      siteNotifications: 'Site Notices',
      clothCategory: 'Categories',
      clothStyle: 'Styles',
      clothSize: 'Sizes',
      productUnit: 'Units',
      clothSizeViewer: 'Size Details',
      videos: 'Help Videos',
      settings: 'Parameters',
      operationLogs: 'Logs',
      fabricCategories: 'Fabric Categories',
      banner: 'Homepage Banners',
      messages: 'Messages',
      clothSizeTemplate: 'Size Templates',
      depositeSettings: 'Recharge Settings',
      course: 'Courses',
      videoCategory: 'Video Categories'
    },
    inventoryTitle: 'Inventory',
    inventory: {
      storage: 'Stock',
      instore: 'Inbound',
      outstore: 'Outbound',
    },
    financialTitle: 'Finance',
    financial: {
      recharge: 'Purchase Records',
      myaccount: 'Fund Account',
      accountStatements: 'Transactions',
      withdrawal: 'Withdrawal',
      depositeRecords: 'Recharge Records',
      depositeHistories: 'Recharge Settings'
    },
    '新增':'Add','启用':'Enable','禁用':'Disable',
    '您确定要重置该机构的管理员密码吗？':'Reset admin password for this org?',
    '确认重置':'Confirm Reset','重置密码':'Reset Password',
    '接收':'On','不收':'Off','不可操作':'N/A',
    '新增账号':'New Account',
    '修改管理员密码':'Change Admin Password',
    '登录名:':'Login Name:','用户名:':'Username:','联系电话:':'Phone:',
    '登录密码:':'Password:','账户角色:':'Role:',
    '原始密码:':'Current Password:','新密码:':'New Password:','验证码:':'Code:',
    '请录入账号登录名!':'Please enter login name!','录入登录名':'Enter login name',
    '请录入录入用户名!':'Please enter username!','录入用户名':'Enter username',
    '请录入联系电话!':'Please enter phone!','录入联系电话':'Enter phone',
    '请录入录入密码!':'Please enter password!','录入密码':'Enter password',
    '请选择账户角色!':'Please select a role!',
    '请录入原始密码!':'Please enter current password!',
    '请录入短信验证码!':'Please enter code!',
    '获取验证码':'Get Code',
    '设置成功':'Saved','发送成功':'Sent',
    '密码已重置为123456':'Password reset to 123456',
    '请录入新密码!':'Please enter new password!',
    '密码至少6位，且包含字母与数字。':'Min 6 chars with letters and numbers.',
    '原始密码不正确。':'Current password incorrect.','密码修改成功。':'Password changed.',
    '账号添加成功。':'Account added.','账号添加失败：':'Failed to add: ',
    '账号修改成功。':'Account updated.','账号修改失败：':'Failed to update: ',
    '版型审核':'Pattern Review','面料审核':'Fabric Review','饰品审核':'Accessory Review',
    '系统添加':'System','管理员添加':'Admin',
    '图标':'Icon','手机号码':'Phone',
    '接收订单消息':'Order Msgs','接收审核消息':'Review Msgs',
    '角色':'Role','账号来源':'Source',
    '创建时间':'Created','最后登录时间':'Last Login',
    '秒后重新获取':'s to retry',
    '登录名、手机号码、用户名':'Login name, phone, or username',
    '雨滴':'Raindrop',
    '修改了超级管理员密码':'Changed super admin password',
    '个人信息':'Profile','更新图标':'Update Icon','个人资料':'Profile',
    '登录名':'Login Name','用户名':'Username','手机号':'Phone','登录时间':'Login Time',
    '所属机构':'Organization','机构类型':'Org Type','编辑个人信息':'Edit Profile',
    '请输入昵称!':'Please enter nickname!','请输入手机号!':'Please enter phone!',
    '所属机构:':'Organization:','保存更改':'Save Changes','机构信息':'Org Info',
    'LOGO白:':'LOGO White:','LOGO黑:':'LOGO Dark:','客服链接:':'Service Link:',
    '机构全称:':'Full Name:','请输入机构全称!':'Please enter full name!',
    '网站地址:':'Website:','机构简称:':'Short Name:','请输入机构简称!':'Please enter short name!',
    '营业执照号:':'License No:','请输入营业执照号!':'Please enter license no!',
    '营业执照:':'License:','机构所在地:':'Location:','请输入机构所在地!':'Please enter location!',
    '机构责任人:':'Contact Person:','请输入机构责任人!':'Please enter contact person!',
    '责任人电话:':'Contact Phone:','请输入责任人电话!':'Please enter contact phone!',
    '责任人证件号:':'ID Number:','请输入责任人身份证号!':'Please enter ID number!',
    '注册类型:':'Reg Type:','微信子商户号:':'WeChat Sub-Merchant:','微信APPID:':'WeChat APPID:',
    '您确定要删除该配置吗，删除后将会影响系统正常支付？':'Delete this config? It will affect payment.',
    '未配置':'Not Configured','扫码绑定打单员':'Scan to Bind Printer',
    '首页设置':'Home Settings','首页标题:':'Home Title:','请输入首页标题!':'Please enter home title!',
    '首页描述:':'Home Desc:','请输入首页描述!':'Please enter home description!',
    '首页图片:':'Home Image:','绑定发货物流':'Bind Shipping',
    '绑定新物流公司':'Add Logistics Co.','微信支付':'WeChat Pay',
    '分账账户':'Settlement Account','开通微信支付':'Enable WeChat Pay',
    '请输入微信子商户号!':'Please enter sub-merchant no!','请输入微信APPID!':'Please enter WeChat APPID!',
    '绑定物流公司':'Bind Logistics Co.','物流公司:':'Logistics Co:','请选择物流公司!':'Please select logistics!',
    '请选择物流公司':'Select logistics','物流账号:':'Logistics Account:','请录入物流账号!':'Please enter logistics account!',
    '请录入物流账号':'Enter logistics account','绑定密码:':'Bind Password:',
    '绑定失败：':'Bind failed: ',
    '解除绑定失败：':'Unbind failed: ','解除绑定成功':'Unbind succeeded',
    '代码':'Code','附加码':'Extra Code','添加时间':'Added',
    '域名已存在':'Domain exists',
    '图片尺寸太小，不符合要求，至少50*50，且长宽比为1:1':'Image too small, min 50*50, ratio 1:1',
    '图片尺寸太大，不符合要求，宽高不能超过800*800，且长宽比为1:1':'Image too large, max 800*800, ratio 1:1',
    '编辑个人账户信息':'Edit Personal Info','保存失败，手机号码可能已使用！':'Save failed, phone may be in use!',
    '请录入正确的域名地址，不包含http/https,例demo':'Enter domain without http/https, e.g. demo',
    '更新成功':'Updated','更新失败，请稍后再次尝试。':'Update failed, please retry.',
    'LOGO图片不符合要求,请重新选择。':'LOGO does not meet requirements, please reselect.',
    '编辑机构信息':'Edit Org Info','保存成功':'Saved',
    '企业':'Enterprise','个人':'Personal',
    '请输入客户姓名、手机号码开始查询':'Search name or phone','客户类别':'Category',
    '会员级别':'Level','导出号码':'Export Phone','个':'',
    '新增会员':'New Member','会员昵称:':'Nickname:','请录入会员昵称!':'Enter nickname!',
    '密码:':'Password:','如不输入，密码默认123456':'Default: 123456',
    '手机号码:':'Phone:','会员等级:':'Level:','会员长度':'Term','会员长度:':'Term:',
    '会员续期':'Renewal','续期长度:':'Renewal Term:','请选择续期长度!':'Select renewal term!',
    '一个月':'1 Month','三个月':'3 Months','六个月':'6 Months','一年':'1 Year','两年':'2 Years','三年':'3 Years',
    '自定义':'Custom','续期长度':'Renewal Term','到期时间:':'Expiry:','请选择到期截止时间!':'Select expiry date!',
    '续期方式:':'Renewal Type:','请选择续期方式!':'Select renewal type!',
    '对公汇款购买升级':'Bank Transfer Upgrade','会员延期':'Extension','其它':'Other','续期方式':'Renewal Type',
    '备注:':'Remark:','续期备注':'Renewal Note','手动续期':'Manual Renewal',
    '续版数量:':'Renewal Qty:','请录入续版数量!':'Enter renewal qty!',
    '支付金额:':'Amount:','支付金额!':'Enter amount!','续期时长:':'Duration:','请选择续期长度':'Select duration',
    '截止时间:':'Deadline:','请录入过期结止时间!':'Enter expiry date!',
    '手动延期':'Manual Extension','对公转账':'Bank Transfer','线下转账':'Offline Transfer',
    '您确定要删除这个客户吗？删除后不可恢复！':'Delete this customer? Cannot be undone!',
    '发券':'Issue Coupon','退卡':'Refund','你确定要':'Are you sure to ','该账号吗？':' this account?',
    '你确定要重置该账号密码吗？默认密码为123456':'Reset password to 123456?',
    '会员备注':'Member Notes','更新备注':'Update Note','会员续期记录':'Renewal Records',
    '序号':'No.','时长':'Duration','续期时间':'Renewal Time','操作员':'Operator',
    '个月':' Months','驳回:':'Rejected:','续期通过':'Approved','待支付':'Pending','天':'d',
    '您确定将当前账号解除黑名单吗？':'Remove from blacklist?',
    '您确定将当前账号拉入黑名单吗？':'Add to blacklist?',
    '充值':'Recharge','消费':'Consume','退费':'Refund',
    '变更会员级别':'Change Level','请选择一个会员级别!':'Select a level!',
    '从一般会员升级为会员，过期日期为当天，请及时为会员续期。':'Upgraded. Expiry is today, please renew.',
    '储值账户退款':'Deposit Refund','账户本金':'Principal','请录入退款金额!':'Enter refund amount!',
    '剩余赠额':'Gift Balance','已用赠额':'Gift Used','实退金额':'Refund Amount',
    '退款说明':'Refund Note','请录入退款说明!':'Enter refund note!','确定退卡':'Confirm Refund',
    '下载限制':'Download Limit','单日下载限制:':'Daily Limit:','单日最大下载限制数量!':'Enter daily limit!',
    '失效日期:':'Expire Date:','请录入失效日期!':'Enter expire date!',
    '失效时间:':'Expire Time:','请录入失效时间!':'Enter expire time!','说明':'Note',
    '1、限制会员单日下载电子版型数量。':'1. Limits daily e-pattern downloads.',
    '2、为0，此设置不限制。':'2. 0 means no limit.',
    '3、不为0且在有限时间内，会限制。':'3. Non-zero within time range will limit.',
    '4、该限制优先于全局限制。':'4. Overrides global limit.',
    '发放优惠券':'Issue Coupon','券名称:':'Coupon:',
    // 2026-09-17：普通身份统一使用用户称谓，并保留旧翻译键。
    '普通会员':'Regular User','普通用户':'Regular User','3个月':'3M','6个月':'6M','12个月':'12M','终身':'Lifetime',
    '客户充值/消费明细':'Recharge/Consumption Details','订单号':'Order No.','充值金额':'Recharge',
    '赠送金额':'Gift','充值时间':'Recharge Time','类型':'Type',
    '下载余量':'Download Quota','账户余额':'Balance','会员过期时间':'Expiry',
    '过期天数':'Days Left','备注':'Remark','黑名单':'Blacklist',
    '1个月':'1M','2个月':'2M','半年':'6M','二年':'2Y','四年':'4Y','五年':'5Y',
    '未过期':'Active','已过期':'Expired','30天内过期':'Expiring 30d','已禁用':'Disabled','储值用户':'Deposit User',
    '实退金额不能小于0!':'Refund cannot be negative!',
    '发放成功':'Issued','当前客户不符合该券的发放要求，发放失败！':'Customer does not meet coupon requirements!',
    '请选择需要发放的优惠券！':'Select a coupon!','备注更新成功':'Note updated',
    '本金':'Principal','已使用赠额':'Gift Used','实退':'Refund',
    '退卡成功':'Refunded','其它会员':'Other Member',
    '新增客户:':'New Customer:','客户新增成功':'Customer added',
    '账号：':'Account: ','的密码':' password','重置密码成功！':'Password reset!',
    '当前客户有未完成的会员续期单据，请完成后再发起续期。':'Pending renewal exists. Complete it first.',
    '续期成功':'Renewed','续期会员':'Renewed member','的有效期':' validity',
    '设置账号的下载限制':'Set download limit',
    '最后登录时间倒序':'Last Login Desc','会员过期时间倒序':'Expiry Desc','会员创建时间倒序':'Created Desc',
    '面料折扣': 'Fabric Discount',
    '购买时长': 'Duration',
    '购买金额': 'Amount',
    '店主购买金额': 'Owner Amount',
    '所衣折扣': 'Garment Discount',
    '饰品折扣': 'Accessory Discount',
    '辅料折扣': 'Material Discount',
    '可下载数量': 'Download Limit',
    '等级名称': 'Level Name',
    '成衣定制折扣': 'Custom Garment Discount',
    '成衣现货折扣': 'Ready-Made Discount',
    '版型下载数量': 'Pattern Download Limit',
    '购买时长(月)': 'Duration(Months)',
    '终端客户购买金额': 'Customer Amount',
    '编辑会员等级': 'Edit Level ',
    '的数据': ' Data',
    '保存成功！': 'Saved!',
    '优惠券设置': 'Coupon Settings',
    '请录入券名称!': 'Please enter coupon name!',
    '请录入券名称，如双十一活动券。': 'e.g. Double 11 Coupon',
    '券类型:': 'Type:',
    '请选择券类型!': 'Please select coupon type!',
    '推荐用户券': 'Referral',
    '活动券': 'Promo',
    '用户券': 'User',
    '核销对象:': 'Targets:',
    '请录入核销对象!': 'Please enter targets!',
    '受众范围:': 'Scope:',
    '请录入受众范围!': 'Please enter scope!',
    '使用门槛:': 'Threshold:',
    '请录入使用门槛!': 'Please enter threshold!',
    '请录入券的最低使用门槛金额。': 'Min. spend amount',
    '券面金额:': 'Amount:',
    '请录入券面金额!': 'Please enter amount!',
    '请录入券面金额。': 'Coupon face value',
    '券有效期:': 'Validity:',
    '请录入券有效时间范围!': 'Please enter validity period!',
    '开始日期': 'Start Date',
    '结束日期': 'End Date',
    '所有券清单': 'All Coupons',
    '停用': 'Disable',
    '设置': 'Edit',
    '确定要删除当前券吗，删除后不可恢复？': 'Delete this coupon? This cannot be undone.',
    '券已过期': 'Expired',
    '消费金额超过': 'Spend over ',
    '已发券清单': 'Issued',
    '发放券': 'Dispatch',
    '未设': 'None',
    '最近一个月未登录': 'No login in 1 month',
    '最近两个月未登录': 'No login in 2 months',
    '最近三个月未登录': 'No login in 3 months',
    '半年未登录': 'No login in 6 months',
    '最近一个月未下单': 'No order in 1 month',
    '最近两个月未下单': 'No order in 2 months',
    '最近三个月未下单': 'No order in 3 months',
    '半年未下单': 'No order in 6 months',
    '会员数:': 'Members:',
    '不重复发放': 'No duplicate',
    '券名称': 'Coupon Name',
    '发放': 'Dispatch',
    '定向生效': 'Targeted',
    '生效周期': 'Cycle',
    '券面金额': 'Amount',
    '受众范围': 'Scope',
    '使用门槛': 'Threshold',
    '开始时间': 'Start',
    '截止时间': 'End',
    '过期时间': 'Expires',
    '累计订单': 'Orders',
    '最后下单时间': 'Last Order',
    '客户': 'Customer',
    '来源': 'Source',
    '发放类型': 'Type',
    '发生时间': 'Time',
    '新增优惠券': 'New Coupon',
    '券类型': 'Type',
    '导出': 'Export',
    '订单列表': 'Order List',
    '支付宝支付': 'Alipay',
    '线下支付': 'Offline Pay',
    '余额支付': 'Balance Pay',
    '退款': 'Refund',
    '确定要作废这个订单吗？': 'Void this order?',
    '作废': 'Void',
    '客户分组': 'Customer Group',
    '订单详情': 'Order Details',
    '客户信息': 'Customer Info',
    '客户姓名': 'Customer Name',
    '联系电话': 'Phone',
    '下单时间': 'Order Time',
    '版型号': 'Pattern No.',
    '数量': 'Qty',
    '订单金额': 'Order Amount',
    '券抵扣': 'Coupon Deduction',
    '版型退款': 'Pattern Refund',
    '退款人': 'Refund By',
    '退款时间': 'Refund Time',
    '留言': 'Message',
    '购买尺码': 'Size',
    '尺码数据': 'Size Data',
    '电话': 'Phone',
    '商品名称': 'Product Name',
    '附件': 'Attachment',
    '尺码': 'Size',
    '评分': 'Rating',
    '店面信息': 'Store Info',
    '订单数量': 'Order Count',
    '门店信息': 'Store Info',
    '电子版型订单': 'E-Pattern Orders',
    '的订单': "'s Orders",
    '复制成功': 'Copied!',
    '无': 'None',
    '订单作废成功！': 'Order voided!',
    '管理员版型退款': 'Admin pattern refund',
    '退款成功': 'Refund success',
    '全部': 'All',
    '客户姓名/手机号/订单号': 'Name/Phone/Order No.',
    '请输入编码、系统编码、版型标题查询': 'Enter code, system code, or pattern title',
  '服装类别': 'Clothing Category',
  '版型/定制': 'Pattern/Custom',
  '添加版型': 'Add Pattern',
  '版型列表': 'Pattern List',
  '版型共享': 'Pattern Sharing',
  '全选': 'Select All',
  '点击开通成衣量体定制': 'Click to enable garment customization',
  '点击修改量体定制价格': 'Click to modify custom price',
  '下载版型': 'Download Pattern',
  '所有面料饰品': 'All Fabrics & Accessories',
  '没有绑定面料或饰品': 'No fabrics or accessories bound',
  '面料饰品': 'Fabrics & Accessories',
  '制版师机构列表': 'Pattern Maker Org List',
  '提交': 'Submit',
  '颜色：': 'Color:',
  '成衣定制上下架': 'Garment Custom List/Delist',
  '恢复': 'Restore',
  '已删除': 'Deleted',
  '面料名称': 'Fabric Name',
  '面料名称：': 'Fabric Name:',
  '请录入面料名称!': 'Please enter fabric name!',
  '请引用面料  →': 'Please reference fabric →',
  '引用面料': 'Reference Fabric',
  '面料颜色：': 'Fabric Color:',
  '请引用面料': 'Please reference fabric',
  '面料款号：': 'Fabric Code:',
  '请录入面料款号!': 'Please enter fabric code!',
  '成衣定制标题：': 'Custom Title:',
  '请录入成衣成衣定制标题!': 'Please enter custom title!',
  '成衣生产加工费：': 'Production Cost:',
  '客户定制成衣价：': 'Customer Custom Price:',
  '会员定制成衣价：': 'Member Custom Price:',
  '成衣定制说明：': 'Custom Description:',
  '请录入成衣描述!': 'Please enter description!',
  '请在此录入成衣定制描述': 'Enter garment custom description',
  '新增面料': 'New Fabric',
  '版型组套': 'Pattern Group',
  '请输入版型标题，代码进行检索': 'Enter pattern title or code',
  '版型类别': 'Pattern Category',
  '审核还未开始，暂无数据。': 'Audit not started yet.',
  '版型浏览': 'Pattern Browse',
  '版型基本信息': 'Pattern Info',
  '版型标题': 'Pattern Title',
  '版型款号': 'Pattern Code',
  '版型价格': 'Pattern Price',
  '服装分类': 'Clothing Category',
  '版型描述': 'Pattern Description',
  '成衣描述': 'Garment Description',
  '版型图片': 'Pattern Images',
  '版型文件': 'Pattern Files',
  '面料信息': 'Fabric Info',
  '面料': 'Fabric',
  '配饰信息': 'Accessory Info',
  '配饰': 'Accessory',
  '流程浏览': 'Process Browse',
  '电子版型': 'Digital Pattern',
  '绑定': 'Binding',
  '恢复成功': 'Restored',
  '开通成功！': 'Activated!',
  '只有开通了成衣定制了才能上下架产品。': 'Enable garment custom first.',
  '账号已停用或绑定错误。': 'Account disabled or binding error.',
  '提交共享成功': 'Sharing submitted',
  '新面料': 'New Fabric',
  '饰品名称:': 'Accessory Name:',
  '请录入饰品名称!': 'Please enter accessory name!',
  '饰品颜色:': 'Accessory Color:',
  '请录入饰品颜色!': 'Please enter accessory color!',
  '饰品款号:': 'Accessory No.:',
  '请录入饰品款号!': 'Please enter accessory No.!',
  '饰品类别:': 'Accessory Category:',
  '请选择饰品类别!': 'Please select accessory category!',
  '成本价格:': 'Cost Price:',
  '请录入商品成本价格!': 'Please enter cost price!',
  '分销价格:': 'Wholesale Price:',
  '请录入商品分销价格!': 'Please enter wholesale price!',
  '销售价格:': 'Sale Price:',
  '请录入商品销售价格!': 'Please enter sale price!',
  '会员价格:': 'Member Price:',
  '请录入商品会员价格!': 'Please enter member price!',
  '销售单位:': 'Sale Unit:',
  '请录入销售单位!': 'Please enter sale unit!',
  '商品描述:': 'Product Description:',
  '请录入商品描述!': 'Please enter product description!',
  '请在此录入商品描述': 'Please enter product description here',
  '单击选择': 'Click to select',
  '一个或多个文件上传': 'one or more files to upload',
  '上传的文件将按文件扩展自动分类': 'Uploaded files will be auto-classified by extension',
  '图片文件': 'Image Files',
  '商品信息': 'Product Info',
  // 2026-08-26: Keep the editable required order remark/message wording consistent in management order details.
  '保存': 'Save','备注/留言信息': 'Remark / Message','请输入备注/留言信息': 'Enter a remark or message','备注/留言信息保存成功': 'Remark / message saved',
  '审核受理中，不可编辑': 'Under review, cannot edit',
  '已审核,不可编辑': 'Reviewed, cannot edit',
  '保存并提交审核': 'Save & Submit for Review',
  '解除审核': 'Release Review',
  '撤销审核申请': 'Revoke Review',
  '返回': 'Back',
  '解锁成功': 'Unlocked',
  '撤销成功': 'Revoked',
  '撤销失败,当前状态不能被撤销。': 'Revoke failed, current status cannot be revoked.',
  '当前账号没有该权限，请联系管理理员': 'No permission, please contact admin',
  '图片删除成功': 'Image deleted',
  '审核通过。': 'Review passed.',
  '提交成功': 'Submitted',
  '饰品新增成功': 'Accessory added',
  '饰品保存成功': 'Accessory saved',
  '请输入编码、系统编码、饰品标题查询': 'Search by code, system code, accessory title',
  '商品共享': 'Product Sharing',
  '共享': 'Share',
  '不共享': 'Not Share',
  '饰品范围': 'Accessory Range',
  '所有饰品': 'All Accessories',
  '上级饰品': 'Parent Accessories',
  '本店饰品': 'Store Accessories',
  '批量上下架': 'Batch List/Delist',
  '查询': 'Search',
  '添加饰品': 'Add Accessory',
  '缩图': 'Thumb',
  '平台编号': 'Platform No.',
  '款号': 'Style No.',
  '状态': 'Status',
  '标题': 'Title',
  '颜色': 'Color',
  '库存数': 'Stock',
  '销售价': 'Sale Price',
  '所属门店': 'Store',
  '上下架时间': 'List/Delist Time',
  '最后修改人': 'Last Modified By',
  '操作': 'Action',
  '修改上架时间': 'Modify Listing Time',
  '确定': 'Confirm',
  '取消': 'Cancel',
  '待审核': 'Pending',
  '已审核': 'Reviewed',
  '已驳回': 'Rejected',
  '审核中': 'Reviewing',
  '上架平台': 'Listed',
  '未通过': 'Failed',
  '下架平台': 'Delist',
  '上架': 'List',
  '下架': 'Delist',
  '编辑': 'Edit',
  '查看': 'View',
  '删除': 'Delete',
  '加颜色': 'Add Color',
  '设为头版': 'Set as Cover',
  '添加饰品颜色': 'Add Accessory Color',
  '饰品标题:': 'Accessory Title:',
  '请录入饰品标题!': 'Please enter accessory title!',
  '饰品编号:': 'Accessory No.:',
  '饰品单位:': 'Accessory Unit:',
  '请录入PLT文件价格!': 'Please enter PLT price!',
  '请录入成本价格!': 'Please enter cost price!',
  '请录入销售价格!': 'Please enter sale price!',
  '确定删除该图片吗？': 'Delete this image?',
  '请选择需要添加的版型。': 'Please select a pattern to add.',
  '审核详情': 'Review Details',
  '审核尚未开始': 'Review not started',
  '不通过': 'Failed',
  '通过': 'Passed',
  '原因：': 'Reason:',
  '审核附件': 'Review Attachments',
  '关闭': 'Close',
  '引用': 'Reference',
  '标题：': 'Title:',
  '请录入版型标题：!': 'Please enter pattern title!',
  '销售价：': 'Sale Price:',
  '会员价：': 'Member Price:',
  '分销价：': 'Wholesale Price:',
  '版型说明：': 'Pattern Note:',
  '请在入版型描述!': 'Please enter pattern description!',
  '请在此录入版型描述': 'Please enter pattern description here',
  '更新': 'Update',
  '删除商品': 'Delete Product',
  '您确认删除该商品吗？删除后不可恢复！！': 'Confirm delete? Cannot be recovered!',
  '请勾选需要批量上下架的产品': 'Select products to list/delist',
  '上级店面的商品': 'Parent Store Products',
  '自已创建的商品': 'My Products',
  '批量上架': 'Batch List',
  '批量下架': 'Batch Delist',
  '删除成功！': 'Deleted!',
  '设置封面成功。': 'Cover set.',
  '操作成功': 'Done',
  '面料标题:': 'Fabric Title:',
  '请录入面料标题!': 'Please enter fabric title!',
  '面料颜色:': 'Fabric Color:',
  '请录入面料颜色!': 'Please enter fabric color!',
  '面料编号:': 'Fabric No.:',
  '面料单位:': 'Fabric Unit:',
  '请输入编码、系统编码、成衣标题查询': 'Search by code, system code, garment title',
  // 2026-08-04：补充面料搜索提示的英文翻译，保持中英文界面含义一致。
  '请输入编码、系统编码、面料标题查询': 'Search by code, system code, fabric title',
  '面料范围': 'Fabric Range',
  '所有面料': 'All Fabrics',
  '上级面料': 'Parent Fabrics',
  '本店面料': 'Store Fabrics',
  '添加面料': 'Add Fabric',
  '创建组套': 'Create Set',
  '保存组套': 'Save Set',
  '取消组套': 'Cancel Set',
  '绑定成衣': 'Bind Garment',
  '添加面料颜色': 'Add Fabric Color',
  '输入关键字查询成衣': 'Search garment by keyword',
  '编号': 'No.',
  '上架时间': 'Listing Time',
  '成衣组套': 'Garment Set',
  '输入编号标题开始查询': 'Search by code or title',
  '选择': 'Select',
  '确认组套': 'Confirm Set',
  '宽度': 'Width',
  '米': 'm',
  '解套': 'Unset',
  '组套': 'Set',
  '确认绑定': 'Confirm Bind',
  '下一步': 'Next',
  '上一步': 'Prev',
  '删除成功': 'Deleted',
  '共享成功': 'Shared',
  '取消共享成功': 'Unshared',
  '设置成功。': 'Set.',
  '版型更新成功': 'Pattern updated',
  '面料新增成功': 'Fabric added',
  '请录入正确的价格!': 'Please enter valid price!',
  '元': 'CNY',
  '博克CAD-PLT-尺码文件': 'CAD-PLT-Size Files',
  '打包下载': 'Download All',
  '版型信息': 'Pattern Info',
  '绑定面料': 'Bind Fabric',
  '绑定配饰': 'Bind Accessory',
  '上传的EXCEL尺码与所选择的尺码类型不匹配': 'Excel sizes mismatch with selected size type',
  '尺码匹配错误': 'Size Mismatch',
  '缺失': 'Missing',
  '忽略': 'Ignore',
  '正在下载文件中，请稍后……': 'Downloading, please wait...',
  '尺码更新成功': 'Size updated',
  '当前账号没有编辑权限，请联系管理员。': 'No edit permission, contact admin.',
  '文件删除成功': 'File deleted',
  '已存在，不能重复添加': 'already exists, cannot add again',
  '上传失败': 'Upload failed',
  '尺码数据匹配错误，请修改后再保存！': 'Size data mismatch, please fix before saving!',
  '版型新增成功': 'Pattern added',
  '版型保存成功': 'Pattern saved',
  '版型保存失败': 'Pattern save failed',
  '面料商:': 'Fabric Supplier:',
  '运单信息:': 'Waybill Info:',
  '运单号:': 'Waybill No.:',
  '服装标题:': 'Garment Title:',
  '请录入服装标题!': 'Please enter garment title!',
  '服装款号:': 'Garment No.:',
  '请录入服装编号!': 'Please enter garment No.!',
  'PLT文件价格:': 'PLT Price:',
  '版型分销价格:': 'Pattern Wholesale:',
  '服装风格:': 'Garment Style:',
  '服装分类:': 'Garment Category:',
  '尺码类型:': 'Size Type:',
  '请选择尺码表类别': 'Please select size chart',
  '适应季节:': 'Season:',
  '春': 'Spring',
  '夏': 'Summer',
  '秋': 'Autumn',
  '冬': 'Winter',
  '版型调整视频:': 'Pattern Video:',
  // 2026-08-04：补充成衣展示视频标签的英文翻译。
  '成衣展示视频:': 'Garment Display Video:',
  '上传视频': 'Upload Video',
  '浏览视频': 'Play Video',
  '动态短视频:': 'Short Video:',
  '请录入动态短视频!': 'Please enter short video!',
  '版型描述:': 'Pattern Description:',
  '请录入录入版型描述!': 'Please enter pattern description!',
  '查看视频': 'View Video',
  '上下架': 'List/Delist',
  '是否共享': 'Shared',
  '平台售卖': 'Platform Sales',
  '服装版型': 'Pattern',
  '成衣定制': 'Custom Garment',
  '该产品处于上架中，不可删除！': 'Product is listed, cannot delete!',
  '该产品处于共享中，不可删除！': 'Product is shared, cannot delete!',
  '请先删除子项！': 'Please delete sub-items first!',
  '只有审核通过的产品才能上架产品。': 'Only reviewed products can be listed.',
  '该产品已停止共享，暂不可上架！': 'Product sharing stopped, cannot list!',
  '原店面已将该产品下架，暂不可上架！': 'Parent store delisted this product!',
  '上架成功！': 'Listed!',
  '下架成功！': 'Delisted!',
  '平台上架提交成功。': 'Platform listing submitted.',
  '平台上架取消成功。': 'Platform listing cancelled.',
  '成组成功': 'Grouped',
  '请至少勾选两个项目进行组套！': 'Select at least 2 items to group!',
  '取消成组成功。': 'Ungrouped.',
  '解套成功。': 'Unset.',
  '绑定成功': 'Bound',
  '当前版型已经绑定了其它成衣，不再能再次绑定了。': 'Pattern already bound to another garment.',
  '绑定失败': 'Bind failed',
  '解绑成功': 'Unbound',
  '分类': 'Category',
  '图片': 'Image',
  'PLT价': 'PLT Price',
  'BOKE价': 'BOKE Price',
}
